import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DateTimeField from "@/components/controls/DateTimeField";
import { FieldDisplayType } from "@/pages/settings/components/dealsSettings/FieldManagement/types";
import { cn } from "@/utils/utils";
import {
  getPlaceholder,
  DATE_FIELD_BADGE_CLASSNAME,
  FIELD_CLASSNAME,
  FOCUS_CLASSNAME,
  HALF_WRAPPER_CLASSNAME
} from "../shared";
import { asString, ControlProps } from "../types";

export const DateControl: React.FC<ControlProps> = ({
  value,
  onChange,
  name,
  dateVariant
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={HALF_WRAPPER_CLASSNAME}>
      <DateTimeField
        type="date"
        name={name}
        value={asString(value)}
        onChange={onChange}
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        placeholder={getPlaceholder(FieldDisplayType.DATE, t)}
        className={cn(
          dateVariant === "field"
            ? FIELD_CLASSNAME
            : DATE_FIELD_BADGE_CLASSNAME,
          isOpen && FOCUS_CLASSNAME
        )}
      />
    </div>
  );
};
